import React, { useState } from "react";
import { FaBriefcase } from "react-icons/fa";
import "./InternshipSection.css";

export function InternshipSection() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", training: "" });

  const trainings = [
    "Rrjetet Sociale",
    "Branding",
    "Web Dizajn",
    "Motion",
    "Konsulencë",
    "Marketing"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = `Aplikim për praktikë: ${formData.training}`;
    const body = `Emri: ${formData.name}\nEmail: ${formData.email}\nTelefoni: ${formData.phone}\nTrajnimi: ${formData.training}`;
    window.location.href = `mailto:academy@fox.illyrian.marketing?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <section className="internship-promo-section">
      <div className="internship-promo-inner">
        <div className="internship-promo-img-col">
          <div className="internship-promo-illustration">
            <FaBriefcase className="internship-promo-icon" />
          </div>
        </div>
        <div className="internship-promo-content">
          <div className="internship-promo-title">
            FITO <span>PRAKTIKË</span>
          </div>
          <div className="internship-promo-desc">
            <b>Të gjithë pjesëmarrësit në kurset tona</b> do të kenë mundësinë
            të përjetojnë një <b>praktikë 1 mujore</b> në Illyrian Marketing!
            <br /><br />
            Praktika është e strukturuar për t’ju ofruar eksperiencë reale pune,
            mentorim nga profesionistë të fushës dhe mundësi të reja për
            zhvillim personal dhe profesional.
          </div>
          <button
            className="internship-promo-btn"
            onClick={() => setShowForm(true)}
          >
            Apliko për TRAJNIM
          </button>
        </div>
      </div>

      {showForm && (
        <form className="internship-form" onSubmit={handleSubmit}>
          <h3>Formular Aplikimi për Praktikë</h3>
          <div className="internship-form-field">
            <label htmlFor="name">Emri i plotë</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="internship-form-field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="internship-form-field">
            <label htmlFor="phone">Telefoni</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="internship-form-field">
            <label htmlFor="training">Zgjidh trajnimin</label>
            <select
              id="training"
              name="training"
              value={formData.training}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                -- Zgjidh --
              </option>
              {trainings.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
        
        </form>
      )}
    </section>
  );
}